export default __webpack_public_path__ + "static/media/spacepath7.d87599b3.png";